import { navigationRef } from './NavigationWrapper';
const navigationHelperViewActions = {
    navigate(name, params) {
        if (navigationRef.isReady()) {
            navigationRef.navigate(name, params);
        }
    },
};
export default navigationHelperViewActions;
